<template>

    <div>

        <b-modal id="bv-modal-pf-overview" hide-footer :title="title" size="lg">
            
            <b-overlay :show="showoverlay" rounded="sm">
                <div>
                    <div class="clearfix pl-0 col-md-12">
                        <div class="row justify-content-center modal-title">
                            <h5 class="modal-title text-center">{{ pf_profile_data.company_name }}</h5>
                        </div>
                        <div class="row justify-content-center pb-4">
                            Employees Provident Fund Scheme - {{ pf_profile_data.employee_name }}
                        </div>
                        <div class='text-right mb-3' @click="getEmployeePfReport(pf_profile_data.employee_id)"><a href="#" class="px-3 py-1 border rounded" style="border:1px solid green !important; color: green;" ><i class="far fa-file-excel mr-1"></i> Download Schedule</a></div>
                        <!-- Mustafijur  -->
                        <div class="row col-12 no-margin px-0">
                            <div class="col-md-12">
                                <div class="ibox-content pf-overview px-0 pb-0">
                                    <div class="payslip-details-info-inner row">
                                        <template >
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee ID</div>
                                                    <div class="second"> {{ pf_profile_data.employee_code }} </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Name</div>
                                                    <div class="second"> {{ pf_profile_data.employee_name }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Job Position</div>
                                                    <div class="second"> {{ pf_profile_data.jobposition }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Joining Date</div>
                                                    <div class="second"> {{ pf_profile_data.joining_date }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">PF Enrollment Date</div>
                                                    <div class="second">{{ pf_profile_data.PF_enrollment_date }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Opening Balance of Fund</div>
                                                    
                                                    <div class="second">{{ formatMoney(pf_profile_data.opening_balance) }}</div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-4 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Service Period</div>
                                                    <div class="second">{{ pf_profile_data.service_period }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">PF Membership Period</div>
                                                    
                                                    <div class="second">{{ pf_profile_data.PF_membership_period }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Closing Balance of Fund</div>
                                                    
                                                    <div class="second">{{ formatMoney(pf_profile_data.closing_balance_of_fund) }}</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">PF Deregistration Date</div>
                                                    
                                                    <div class="second">{{ pf_profile_data.pf_leave_date }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Disbursed Settlement Amount</div>
                                                    
                                                    <div class="second">{{formatMoney(0.00)}}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Settlement Status</div>
                                                    
                                                    <div class="second">N/A</div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 payslip-details-info-right">
                                            
                                                <div class="wrapper">
                                                    <div class="first">Reconsilied Settlement Amount</div>
                                                    
                                                    <div class="second">{{formatMoney(0.00)}}</div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <!-- Mustafijur  -->
                    </div>
                </div>

                <template v-if = "is_end">

                    <b-form @submit.stop.prevent="endEmployeePF">                    
                        <div class="clearfix">                                         
                            <div class="row clearfix">
                            <div class="col-md-6 mx-auto pt-4">                                         
                              
                                <b-form-group id="settlement_date-group" label="PF Enrollment End Date" label-for="settlement_date" class="required-field">
                                    <b-input-group class="m-0"> <!-- Mustafijur: 16-07-2026: added m-0 -->
                                        <b-form-input id="settlement_date"  :state="validateState('settlement_date')" name="settlement_date" v-model="curr_approve_date"  type="text" placeholder="YYYY-MM-DD" autocomplete="off" v-validate="{required:true,date_format:'yyyy-MM-dd' }"  aria-describedby="settlement_date-feedback" data-vv-as="Date"></b-form-input>
                                        <b-form-datepicker id="settlement_date" button-only right locale="en-US" v-model="curr_approve_date" :min="min_date"></b-form-datepicker>

                                        <b-form-invalid-feedback id="settlement_date-feedback">{{ veeErrors.first('settlement_date') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                                
                                <!-- <b-form-group id="pf_end_date-group" label="PF Enrollment End Date [YYYY-MM-DD]" label-for="pf_end_date">
                                    <b-input-group class="mb-3" >
                                        <b-form-input id="pf_end_date"  name="pf_end_date" v-model="curr_approve_date" v-validate="{required:true,date_format: 'yyyy-MM-dd', min_date: min_date}" type="text" placeholder="YYYY-MM-DD" autocomplete="off"  aria-describedby="pf_end_date-feedback" data-vv-as="PF Enrollment End Date"></b-form-input>
                                        <b-form-datepicker id="day_one"  button-only right locale="en-US" :min="min_date"  v-model="curr_approve_date"></b-form-datepicker>
                                        <b-form-invalid-feedback id="pf_end_date-feedback">{{ veeErrors.first('pf_end_date') }}</b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group> -->
                            </div> 
                            <div class="col-md-6 mx-auto pt-4">    
                                <b-form-group id="settlement_reason-group" label="PF Seperation Reason" label-for="settlement_reason" class="required-field">
                                    <b-form-select class="" id="settlement_reason" name="settlement_reason" v-model="pf_reason" v-validate="{ required: true }" :options="pf_reason_options" :aria-required="true"  placeholder="Please select" :state="validateState('settlement_reason')" aria-describedby="settlement_reason-feedback" data-vv-as="PF Seperation Reason"> </b-form-select>
                                    <b-form-invalid-feedback id="settlement_reason">{{ veeErrors.first('settlement_reason') }}</b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            </div>                           
                        </div>
                        <div class="mt-1 ml-4 mb-4 pb-3 clearfix text-center" style="margin-right: 0;">
                            <b-button class="btn border rounded bg-light px-5 btn-primary" type="submit" variant="primary">Submit</b-button>
                        </div>
                    </b-form> 

                   
                </template>

            </b-overlay>
        </b-modal>
    </div>

</template>

<script>
export default{
    props: ['pageurl','employee_id','title','show','is_end','curr_pf_id'],
    data(){      
        return {
            dreg_show:1,
            showoverlay:false,
            pf_profile_data:[],
            curr_approve_date:'',
            curr_emp_id:'',
            min_date:'',
            pf_reason:null,
            pf_reason_options: [],
            
        }
    },
    methods:{
        // Start: Rejwan: 24-04-2025 2 decimal
        // formatMoney: function(amount){
        //     var money = Number(amount);

        //     if(this.$atl_company_number_format == 'no')
        //     {
        //         money = Math.round(money);
        //         money = money.toLocaleString();
        //     }
        //     else
        //     {
        //         money = money.toLocaleString();
        //         if(money=='NaN')
        //         money = amount;
        //         else{
        //         if(money.indexOf(".")<0)
        //         money = money+".00";
        //         }

        //     }
            
        //     return money;
        // },  
        pfDetailsNew: function(employee_id)
        { 
            if(employee_id>0)
            {
                let currentObj = this;
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('employee_id', employee_id); 
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                axios.post(this.$api_url + '/pf/report/profile', formData)
                .then(function (response) 
                {
                    this.pf_profile_data = response.data.file_name.employee_info;
                   
                    if(this.is_end == 1)
                    {
                        this.min_date = this.pf_profile_data.available_date;
                        this.curr_emp_id = this.pf_profile_data.employee_id;

                        if(this.pf_profile_data.pf_leave_date != '--')
                        {
                            this.curr_approve_date = this.pf_profile_data.pf_leave_date;  
                        }
                        else
                        {
                            this.curr_approve_date = '';
                        }


                        this.pf_reason = null;
                        
                        axios.get(this.$api_url + '/pf/active-settle-reasons')
                        .then(response => {
                            let pfoptions = response.data.map(item => ({
                                value: item.id,
                                text: item.title,
                                is_default: item.is_default
                            }));

                            let defaultItem = pfoptions.find(item => item.is_default == 1);
                            if (defaultItem) {
                                this.pf_reason = defaultItem.value;
                            }

                            this.pf_reason_options = [
                                { value: null, text: 'Please select' },
                                ...pfoptions
                            ];
                            
                        });



                        
                    }
                    this.showoverlay = false;
                    this.$bvModal.show('bv-modal-pf-overview');
                     
                }.bind(this))
                .catch(function (error) 
                {
                    console.log(error);
                }); 

            }
            

        },
        endEmployeePF: function()
        {
            this.$validator.validateAll().then(result => 
            {
                if (!result) {        
                    return;
                }
                if(this.curr_pf_id && this.curr_approve_date)
                {
                    var curr_obj = this;
                    let formData = new FormData();
                    formData.append('id', this.curr_pf_id);
                    formData.append('pf_end_date', this.curr_approve_date);
                    formData.append('seperation_reason', this.pf_reason);
                    axios.post(this.$api_url + '/pf/employee/update', formData)
                    .then(function (response) 
                    {
                        if(response.data.success){
                            curr_obj.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                            curr_obj.curr_emp_id =0;
                            curr_obj.curr_pf_id =0;
                            curr_obj.curr_approve_date ='';
                            this.$bvModal.hide('bv-modal-pf-overview');
                            this.$emit('childToParent');
                           
 
                        }else if(response.data.errors){
                            curr_obj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});  
                        }
                    }.bind(this))
                    .catch(function (error) 
                    {
                        currentObj.errormsg = error.response.data.errors;
                    }); 
                }
                else
                {
                    this.$bvToast.toast("Please choose employee and enter PF end date", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
            });
        },
       
        getEmployeePfReport: function(employee_id)
        { 
            if(employee_id>0){
                var curr_obj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_id); 
                formData.append('d_type', 'excel'); 
                this.loader = true;

                this.downloadBlobResponse(
                    axios.post(this.$api_url + '/pf/report/profile', formData, { responseType: 'blob' }),
                    'loader' // your loader key in this component
                );

            }

        }, 
        download_file(fileURL) 
        {
            if(!this.checkNet()) return false;
            
            var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
            if (!window.ActiveXObject) {
                var save = document.createElement('a');
                save.href = fileURL;
                save.target = '_blank';
                //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                save.download = fileName || filename;
                if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                        document.location = save.href;
                    }else{
                        var evt = new MouseEvent('click', {
                            'view': window,
                            'bubbles': true,
                            'cancelable': false
                        });
                        save.dispatchEvent(evt);
                        (window.URL || window.webkitURL).revokeObjectURL(save.href);
                    }    
            }
            else if ( !! window.ActiveXObject && document.execCommand)     {
                var _window = window.open(fileURL, '_blank');
                _window.document.close();
                _window.document.execCommand('SaveAs', true, fileName || fileURL)
                _window.close();
            }
        },
        endEmployasdeePF: function()
        {
                

            
        },
    },
    created: function(){
          if(this.show > 0 && this.employee_id > 0)
          {
            this.pfDetailsNew(this.employee_id);
          }
    },
    computed: 
    {
        
    }
}
</script>